module.exports = __webpack_public_path__ + "static/media/990291.dda259e2.png";